import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ItemTypeOverride, CosmeticOptions } from '../../models/filter-models';
import { Rarity, MinimapIconShape } from '../../models/enums';
import { FormsModule } from '@angular/forms';
import { CosmeticSettingsComponent } from '../cosmetic-settings/cosmetic-settings.component';
import { LabelViewerComponent } from '../../common/label-viewer/label-viewer.component';
import { CosmeticControls } from '../cosmetic-controls.model';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { SelectMinimapIconComponent } from '../../common/select/select-minimap-icon/select-minimap-icon.component';
import { BaseComponent } from '../../common/base.component';

@Component({
  selector: 'app-item-type-override-cosmetics',
  imports: [FormsModule, CosmeticSettingsComponent, LabelViewerComponent, FilterTitleComponent, SelectMinimapIconComponent],
  templateUrl: './item-type-override-cosmetics.component.html',
  styleUrl: './item-type-override-cosmetics.component.scss'
})
export class ItemTypeOverrideCosmeticsComponent extends BaseComponent implements OnInit {
  @Input({ required: true }) override!: ItemTypeOverride;
  @Input() rarity?: Rarity;
  @Input({ required: true }) exampleName!: string;
  @Input() descriptionText?: string;

  @Input() isCurrency?: boolean;
  @Input() isWaystone?: boolean;
  @Input() isPoe1Gem?: boolean;

  @Output('updateFilter') updateFilterEmitter = new EventEmitter<void>();

  Rarity = Rarity;
  MinimapIconShape = MinimapIconShape;
  cosmeticControls = new CosmeticControls();

  dirtyForceUpdate = 0;

  ngOnInit() {
    // Ensure cosmeticOptions exists for ngModel binding
    if (!this.override.displayOptions.cosmeticOptions) {
      this.override.displayOptions.cosmeticOptions = new CosmeticOptions();
    }
  }

  toggle() {
    this.override.displayOptions.active = !this.override.displayOptions.active;
    this.dirtyForceUpdate++;
    this.updateFilter();
  }

  toggleMinimapIconShape() {
    if (!this.override.displayOptions.cosmeticOptions) {
      this.override.displayOptions.cosmeticOptions = new CosmeticOptions();
    }

    if (this.override.displayOptions.cosmeticOptions.minimapIconShape) {
      this.override.displayOptions.cosmeticOptions.minimapIconShape = undefined;
    } else {
      // Use existing value or default to Circle
      this.override.displayOptions.cosmeticOptions.minimapIconShape = MinimapIconShape.Circle;
    }
    this.dirtyForceUpdate++;
    this.updateFilter();
  }

  updateFilter() {
    this.updateFilterEmitter.emit();
  }
}

